import "./RequestSent.scss";
import logo from "../../assets/logo/logo.png";

const Loading = () => {
  return (
    <div className="request-sent">
      <img src={logo} alt={"logo"} className="request-sent__logo" />
      <p className="request-sent__text">
        Your request has been sent, <br /> low key bakerr will be in touch{" "}
        <br /> in 24 hours
      </p>
    </div>
  );
};

export default Loading;
